/* eslint-disable jam3/no-sanitizer-with-danger */
import React from 'react';

const ChallengeDescription = ({ description, importance='sss', showMore, classes }) => {
  return (
    <div className={classes.challengeDesc}>
      <h3 className={classes.header}>Challenge description</h3>
      <div className={classes.wrp}>
        <p className={classes.challengeDesc_ans}>
          {/* {description} */}
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </p>
      </div>

      {importance.trim().length > 0 && (
        <>
          <h3 className={classes.header}>Why is this important?</h3>
          <div className={classes.wrp}>
            <p className={classes.challengeDesc_ans}>{importance}
              {/* <div dangerouslySetInnerHTML={{ __html: importance }} /> */}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default ChallengeDescription;
